import React, { FC, useCallback, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { toast } from 'react-toastify'
import { KeyValue } from '../../../../components/Dashboard/KeyValue'
import { SingleLabel } from '../../../../components/Dashboard/SingleLabel'
import { useRest } from '../../../../components/Context'
import { Loader } from '../../../../components/Loader'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
    paddingBottom: theme.spacing(2),
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(4, 4, 2, 4),
    background: theme.palette.background.paper,
  },
}))

interface KYCStatusSectionProps {
  title?: string
  idSf?: string
}

export const KYCStatus: FC<KYCStatusSectionProps> = ({ title, idSf }) => {
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})

  const loadData = useCallback(async () => {
    setLoading(true)

    rxiosAuth.get('user/sumsub/profile').subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setValues(next.steps)
        // console.log(next)
        setLoading(false)
      },
      (error) => {
        toast.error(error)
        setLoading(false)
      },
    )
  }, [rxiosAuth])

  const loadUserData = useCallback(async () => {
    setLoading(true)

    rxiosAuth.get(`user/sumsub/profile/${idSf}`).subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setValues(next.steps)
        // console.log(next)
        setLoading(false)
      },
      (error) => {
        toast.error(error.response.data.message)
        setLoading(false)
      },
    )
  }, [rxiosAuth, idSf])

  useEffect(() => {
    if (idSf) {
      ;(async () => {
        await loadUserData()
      })()
    } else {
      ;(async () => {
        await loadData()
      })()
    }
    // eslint-disable-next-line
  }, [idSf])

  return (
    <>
      <Grid item xs={12} className={classes.formWrap}>
        <Grid item xs={12} className={classes.container}>
          <Typography variant={'h6'}>{title}</Typography>
        </Grid>

        {loading ? (
          <Loader />
        ) : (
          <Grid item xs={12} className={classes.sectionWrap}>
            <KeyValue labelKeyValue="Identification Status" minWidth="550px">
              <SingleLabel labelValue={values && values.IDENTITY?.status ? values.IDENTITY.status : '-'} />
            </KeyValue>
            <KeyValue labelKeyValue="Proof of Address Status" minWidth="550px">
              <SingleLabel
                labelValue={values && values.PROOF_OF_RESIDENCE?.status ? values.PROOF_OF_RESIDENCE.status : '-'}
              />
            </KeyValue>
            <KeyValue labelKeyValue="Selfie Status" minWidth="550px">
              <SingleLabel labelValue={values && values.SELFIE?.status ? values.SELFIE.status : '-'} />
            </KeyValue>
            <KeyValue labelKeyValue="Sophisticated Questionaire Status" minWidth="550px">
              <SingleLabel labelValue={'-'} />
            </KeyValue>
          </Grid>
        )}
      </Grid>
    </>
  )
}
